export type Rule = (value: string) => boolean;

const rules: {
  [key: string]: Rule;
} = {
  notEmpty : (value) => {
    return !!value;
  }
}
export default rules;